<template>
  <div>
    <!-- Tip -->
    <Tip v-show="tip_flag"></Tip>
    <router-view />
  </div>
</template>

<script>
import Tip from "@/components/Tip.vue";
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  components: {
    Tip
  },
  computed: {
    ...mapState("packet", {
      tip_flag: "tip_flag"
    })
  }
};
</script>